const validateDni = (id: string): boolean => {
  const DNI_REGEX = /^(\d{8})([A-Z])$/

  const dni = id.toUpperCase().replace(/\s/, '')
  if (!DNI_REGEX.test(dni)) {
    return false
  }

  const dni_letters = 'TRWAGMYFPDXBNJZSQVHLCKE'
  const letter = dni_letters.charAt(parseInt(dni, 10) % 23)
  return letter == dni.charAt(8)
}

export default validateDni
